export default "__VITE_ASSET__D62d9G2Y__"